export const waitForFirebaseUser = (auth, onAuthStateChanged, timeoutMs = 10000) => {
  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser);
  }

  return new Promise((resolve, reject) => {
    let unsubscribe = () => {};

    const timeoutId = setTimeout(() => {
      unsubscribe();
      reject(new Error('User authentication could not be restored'));
    }, timeoutMs);

    unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) return;

      clearTimeout(timeoutId);
      unsubscribe();
      resolve(user);
    });
  });
};
